<template>
  <div id="basic">
    <div class="top_div">
      <el-form :inline="true" :model="formInline">
        <div class="demo-form-inline">
          <el-form-item label="选择门店">
            <el-select v-model="formInline.id" placeholder="请选择" @change="getRecepit">
              <el-option
                  v-for="index in typeDate"
                  v-bind:key="index.id"
                  :label="index.name"
                  :value="index.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <el-dialog title="小票机信息" :visible.sync="dialogVisible">
        <el-form :model="form">
          <el-form-item label="条码" label-width="120px">
            <el-input v-model="form.sn" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancelDig">取 消</el-button>
          <el-button type="primary" @click="submitReceipt">确 定</el-button>
        </div>
      </el-dialog>

      <div class="basic_top">
        <div>小票机信息</div>
        <div style="color: #1890ff; cursor: pointer;" v-if="receipt.id > 0" @click="editReceipt">编辑</div>
        <div style="color: #1890ff; cursor: pointer;" v-if="receipt.id === 0" @click="addReceipt">添加</div>
      </div>
      <div class="basic_value">
        <div class="basic_value_s">
          <span>条码:</span>
          <span>{{receipt.sn}}</span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'employee',
  data() {
    return {
      dialogVisible: false,
      form: {
        sn: '',
        id: 0,
      },
      formInline: {
        user: '',
        id: '',
      },
      page_no: 0,
      typeDate: [],
      receipt: {
        id: 0,
        sn: '',
        shop_id: 0
      }
    };
  },
  methods: {
    getType() {
      const url = this.$userList.user_restaurant_list + `/${this.page_no}/999`;
      this.$http.get(url).then(res => {
        if (res.code === 200) {
          this.typeDate = res.data.items;
          this.formInline.id = res.data.items[0].id;
          this.getRecepit()
        } else {
        }
      });
    },
    getRecepit() {
      const url = this.$userList.fetch_receipt + `/${this.formInline.id}`;
      this.$http.get(url).then(res => {
        console.log(res)
        this.receipt = res.data
      })
    },
    addReceipt(){
      this.dialogVisible = true
      this.form.id = 0
    },
    editReceipt() {
      this.dialogVisible = true
      this.form.sn = this.receipt.sn
      this.form.id = this.receipt.id
    },
    submitReceipt(){
      const url = this.$userList.fetch_receipt;
      this.receipt.sn = this.form.sn
      this.receipt.shop_id = this.formInline.id
      this.$http.post(url, this.receipt).then(res=>{
        console.log(res)
        this.dialogVisible = false
        this.getRecepit()
      })
    },
    cancelDig(){
      this.dialogVisible = false
    }
  },
  created() {
    this.getType();
  },
};
</script>

<style scoped>
#basic {
  width: 100%;
  height: 100%;
  position: relative;
}
.top_div {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 20px;
  background: #fff;
}
.demo-form-inline {
  display: flex;
  justify-content: flex-start;
}
/* .el-select > .el-input,
.el-input__inner {
  width: 300px;
} */
.vubutton {
  background: #fff;
  border: solid 1px #1890ff;
  color: #1890ff;
}
.el-button--primary:hover,
.el-button--primary:active,
.el-button--primary:focus {
  background: #1890ff;
  border-color: #1890ff;
}
.el-table--group::after,
.el-table--border::after,
.el-table::before {
  background: none;
}
.el-form--inline .el-form-item {
  margin-right: 50px;
}
.center_div {
  margin-top: 20px;
  background: #fff;
  box-sizing: border-box;
  padding: 20px;
}
.el-table__empty-block {
  width: none !important;
}
.center_div_border {
  margin-top: 20px;
  width: 100%;
  min-height: 300px;
  background: brown;
}
.pagination {
  margin-top: 20px;
  text-align: center;
}
.bottom_center {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.basic_top {
  width: 100%;
  display: flex;
  font-size: 16px;
  justify-content: space-between;
  padding-bottom: 20px;
  border-bottom: solid 1px rgb(160, 160, 160);
}
.basic_value,
.basic_value_s {
  width: 100%;
  height: auto;
}
.basic_value_s {
  margin-top: 20px;
}
.basic_value_s span:nth-child(1) {
  margin-right: 20px;
}
</style>
